'use strict';

module Patersons {

   export interface ClientAdviserScope extends ng.IScope {
        selectedAccountId: string;
        adviserList: Array<Patersons.ClientAdviser>;
        adviserLabel: string;
        selectedAdviser: Patersons.ClientAdviser;
        selectedAdviserId: string;
        events: Patersons.ClientAdviserViewCtrl;
        parentController: AbstractController;
        isLoading: boolean;
        isLoggedIn: boolean;
        ShowFullImage;
     }
    export class ClientAdviserViewCtrl extends AbstractController {
        scope: Patersons.ClientAdviserScope;
        clientConfigService: Patersons.ClientConfigService;
        tokenService: Patersons.TokenService;
 
        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'tokenService', 'clientConfigService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, tokenService, clientConfigService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.scope = $scope;
            this.tokenService = tokenService;
            this.clientConfigService = clientConfigService;

            if (this.tokenService.tokenManager && !this.tokenService.tokenManager.expired) {
                this.getAdviserData();

                this.scope.ShowFullImage = function (url: string) {
                    $('.imagepreview').attr('src', url);
                    $('#imagemodal').modal('show');
                };
            }
        }
        getAdviserData() {
            this.scope.isLoading = true;
            var promise = this.clientConfigService.getAdviser();
            promise.then((result) => {
                this.scope.isLoading = false;
                this.scope.adviserList = result;
                if (this.scope.adviserList.length > 1) {
                    this.scope.adviserLabel = "Meet your Advisers";
                } else if (this.scope.adviserList.length == 1) {
                    this.scope.adviserLabel = "Meet your Adviser";
                } else if (this.scope.adviserLabel.length == 0) {
                    this.scope.adviserLabel = "";
                }
                if (this.tokenService.tokenManager) {
                    this.scope.isLoggedIn = !this.tokenService.tokenManager.expired;
                }
           },
                (reason) => {
                    this.scope.isLoading = false;
                    this.clientConfigService.errorHandler = reason.data;
                }
            );
            return null;
        }
    }
}
